'use client';

import { useLoadingBar } from './loading-bar-context';

export const LoadingBar = () => {
  const { loading, progress } = useLoadingBar();

  if (!loading) return null;

  return (
    <div className='fixed left-0 right-0 top-0 z-50 h-1'>
      <div
        className='h-full bg-blue-500 transition-all duration-300 ease-out'
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
